// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2LdRR","label":"Checkbox_label__18RMf","input":"Checkbox_input__JC9f1"};